import { Receipt, AlertTriangle } from "lucide-react";
import FoundationRefPicker from "./FoundationRefPicker";

const SOURCE_LABEL = {
  override: "chosen for this push",
  mapping: "Tax Codes mapping",
  identity: "the WO's own tax number (matches a Foundation tax code)",
};

// Confirm Tax No — mandatory read-before-push step in the Foundation preview.
// Shows the WO's tax number, the Foundation tax_no it resolves to, and lets
// accounting pick a different one from the synced sales_taxes list. A changed
// value is written back to the WO after a successful push.
export default function FoundationTaxConfirm({ tax, value, onChange, disabled, testIdPrefix = "sp" }) {
  if (!tax || tax.mode === "neither") return null;
  const resolved = value || tax.resolved;
  const changed = !!value && value !== tax.wo_tax_no;
  return (
    <div className="rounded-md border border-slate-200 bg-white p-2 space-y-1.5" data-testid={`${testIdPrefix}-tax-confirm`}>
      <div className="flex items-center gap-1 font-semibold text-slate-700">
        <Receipt className="w-3.5 h-3.5" /> Confirm Tax No
        <span className="font-normal text-slate-500">— sent as {(tax.params || []).map(p => `@${p}`).join(" + ")}</span>
      </div>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
        <div>
          <span className="text-slate-500">Work order tax number: </span>
          <code className="text-slate-900" data-testid={`${testIdPrefix}-tax-wo-code`}>{tax.wo_tax_no || "—"}</code>
        </div>
        <div>
          <span className="text-slate-500">Foundation tax_no: </span>
          <code className={resolved ? "text-emerald-700 font-semibold" : "text-rose-700"} data-testid={`${testIdPrefix}-tax-resolved`}>
            {resolved || "not resolved"}
          </code>
          {tax.resolved_label && <span className="text-slate-500"> · {tax.resolved_label}</span>}
          {tax.source && <span className="text-slate-400"> (via {SOURCE_LABEL[tax.source] || tax.source})</span>}
        </div>
      </div>
      {!tax.resolved && tax.reason && (
        <div className="text-amber-800 flex items-center gap-1" data-testid={`${testIdPrefix}-tax-reason`}>
          <AlertTriangle className="w-3 h-3" /> {tax.reason} — pick one below or the tax parameter is withheld.
        </div>
      )}
      <div className="flex items-center gap-2">
        <span className="text-slate-500">Change to:</span>
        <FoundationRefPicker listId="tax_codes" value={value || null} onChange={(code) => onChange(code)}
                             disabled={disabled} placeholder="Keep as shown"
                             testId={`${testIdPrefix}-tax-picker`} />
        {changed && (
          <span className="text-[11px] text-amber-800 bg-amber-50 border border-amber-200 rounded px-1.5 py-0.5" data-testid={`${testIdPrefix}-tax-changed`}>
            Will be saved on the work order after a successful push
          </span>
        )}
      </div>
    </div>
  );
}
